module.exports = __webpack_public_path__ + "img/product2.d144e10e.png";